import * as React from 'react'
import Helmet from 'react-helmet'

export const FacebookAppId = () => (
  <Helmet>
    <meta property="fb:app_id" content="2473951522635875" />
  </Helmet>
)
